import { Logo } from "@/components/Logo";

const HERO = "https://images.unsplash.com/photo-1627920769541-daa658ed6b59?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const AuthLayout = ({ title, subtitle, children }) => (
  <div className="min-h-screen lg:grid lg:grid-cols-[1.1fr_1fr] bg-[#F4F1EA]">
    <div className="relative grain h-44 sm:h-56 lg:h-auto overflow-hidden">
      <img src={HERO} alt="Lavoura" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-[#1E4D2B]/70" />
      <div className="relative h-full flex flex-col justify-between p-6 lg:p-14">
        <Logo light size="lg" />
        <div className="hidden lg:block max-w-md">
          <h1 className="text-5xl font-extrabold text-white leading-[1.05]">Tecnologia que trabalha junto com o campo.</h1>
          <p className="mt-5 text-white/80 text-lg">Clientes, fazendas, equipamentos e serviços em um só lugar — feito para usar no celular.</p>
        </div>
      </div>
    </div>
    <div className="flex items-start lg:items-center justify-center px-5 py-8 lg:p-14 -mt-6 lg:mt-0 relative">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl shadow-[#1E4D2B]/5 border border-[#E2DDD3] p-6 sm:p-8 fade-up">
        <h2 className="text-3xl font-extrabold text-[#1B2A26]" data-testid="auth-title">{title}</h2>
        {subtitle && <p className="mt-2 text-[#5C6B66]">{subtitle}</p>}
        <div className="mt-7">{children}</div>
      </div>
    </div>
  </div>
);
